<div class="container">
  <div class="header">
    <div class="title">
      @if (!alreadyAccepted) {
        <span [fiTranslation]="'REQUEST_DETAIL_SKELETON_ACCEPT_ENQUIRY_HEADLINE'"></span>
      }
      @if (alreadyAccepted) {
        <span
          [fiTranslation]="'ACTION_ACCEPT_BROKER_ENQUIRY_TOO_LATE_HEADLINE'"
        [params]="{ AcceptTooLateDate: acceptedDate, AcceptTooLateTime: acceptedTime }"></span>
      }
    </div>
    @if (!alreadyAccepted) {
      <button (click)="onClosePopup()">
        <img alt="Close" src="/assets/icons/close-icon.svg">
        <span class="u-hidden-visually" fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
      </button>
    }
  </div>

  @if (alreadyAccepted) {
    <div class="description" [fiTranslation]="'ACTION_ACCEPT_BROKER_ENQUIRY_TOO_LATE_TEXT'"></div>
  }

  @if (!alreadyAccepted) {
    <div class="description"
    [fiTranslation]="'REQUEST_DETAIL_SKELETON_ACCEPT_ENQUIRY_TEXT'"></div>
    @if (showWarning) {
      <div class="warning-container" [fiTranslation]="'ACTION_ACCEPT_BROKER_ENQUIRY_INFO_ALREADY_ACCEPTED'"></div>
    }
  }

  <div class="button-row">
    @if (!alreadyAccepted) {
      <button class="cancel" (click)="cancel()">
        <span class="btn-title" [fiTranslation]="'REQUEST_OVERVIEW_ACTION_DECLINE_ENQUIRY'"></span>
      </button>
      <button (click)="confirm()">
        <span class="btn-title" [fiTranslation]="'REQUEST_OVERVIEW_ACTION_ACCEPT_ENQUIRY'"></span>
      </button>
    }
    @if (alreadyAccepted) {
      <button class="text-button" (click)="cancel()">
        <span class="btn-title" [fiTranslation]="'ACTION_ACCEPT_BROKER_ENQUIRY_TOO_LATE_LINK'"></span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M16.6269 12.75H4.5V11.25H16.6269L10.9308 5.55383L12 4.5L19.5 12L12 19.5L10.9308 18.4461L16.6269 12.75Z" fill="black"/>
        </svg>
      </button>
    }
  </div>

</div>

